import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getJefeInmediatoHttp,
} from "actions/requisiciones";
import {
  activarProveedorHttp,
  createEditProveedorHttp,
  desactivarProveedorHttp,
  editarDocumentoProveedorHttp,
  eliminarDocumentoProveedorHttp,
  getDocumentosFaltantesProveedorHttp,
  getProveedoresHttp,
  subirDocumentoProveedorHttp,
} from "actions/proveedores";

export const useProveedores = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);
  const idAreaDireccionUsuario = useSelector(
    (state: StoreType) => state?.app?.user?.data?.id_area || 0
  );

  const [procesando, setProcesando] = useState<boolean>(true);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const [errorLogin, setErrorLogin] = useState(false);
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  const [verEditarProveedor, setVerEditarProveedor] = useState<any>(null);
  const [procesandoProveedor, setProcesandoProveedor] = useState<boolean>(false);
  const [isAlertOpenCrearProveedor, setIsAlertOpenCrearProveedor] = useState(false);
  const handleisAlertOpenCrearProveedor = () => setIsAlertOpenCrearProveedor(true);
  const handleisAlertCloseCrearProveedor = () => setIsAlertOpenCrearProveedor(false);

  const [proveedores, setProveedores] = useState<any[]>([]);

  // Estados para la paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //para buscador
  const [buscador, setBuscador] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

  //Modal de ver detalles del proveedor
  const [verDetalleProveedor, setVerDetalleProveedor] = useState<any>(null);
  const [isAlertOpenDetalleProveedor, setIsAlertOpenDetalleProveedor] = useState(false);
  const handleisAlertOpenDetalleProveedor = () => setIsAlertOpenDetalleProveedor(true);
  const handleisAlertCloseDetalleProveedor = () => setIsAlertOpenDetalleProveedor(false);

  //Modal para añadir documentos al proveedor
  const [procesandoSubirDocumento, setProcesandoSubirDocumento] = useState<boolean>(false);
  const [idDocumento, setIdDocumento] = useState<number | null>(null);
  const [documentosProveedor, setDocumentosProveedor] = useState<any[]>([]);
  const [isAlertOpenDetalleDocumentos, setIsAlertOpenDetalleDocumentos] = useState(false);
  const handleisAlertOpenDetalleDocumentos = () => setIsAlertOpenDetalleDocumentos(true);
  const handleisAlertCloseDetalleDocumentos = () => setIsAlertOpenDetalleDocumentos(false);
  const [archivo, setArchivo] = useState<File | null>(null);
  const handleChangeDocumento = (newFile: File | null) => {
    setArchivo(newFile);
  };

  //ver documento individualmente
  const [isModalVistaDocumento, setIsModalVistaDocumento] = useState(false);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState<any>(null);
  const [idRegistroDocumento, setIdRegistroDocumento] = useState<number | null>(null);

  //tabs de areas de registro de proveedores
  const [selectedArea, setSelectedArea] = useState<number | null>(null);

  const handleOpenVistaDocumento = (documento: any) => {
    setDocumentoSeleccionado(documento);
    setIsModalVistaDocumento(true);
  };
  const handleCloseVistaDocumento = () => {
    setIsModalVistaDocumento(false);
    setDocumentoSeleccionado(null);
  };

  // Áreas únicas presentes en los proveedores
  const areas = useMemo(() => {
    const mapa = new Map<number, string>();
    proveedores.forEach((p) => {
      if (p.id_area != null && !mapa.has(p.id_area)) {
        mapa.set(p.id_area, p.nombre_area);
      }
    });
    return Array.from(mapa, ([id_area, nombre_area]) => ({ id_area, nombre_area }));
  }, [proveedores]);

  // Cuando llegan los proveedores, seleccionar tab default = área del usuario si existe, si no la primera
  useEffect(() => {
    if (areas.length === 0) return;
    if (selectedArea === null) {
      const existeAreaUsuario = areas.some((a) => a.id_area === idAreaDireccionUsuario);
      setSelectedArea(existeAreaUsuario ? idAreaDireccionUsuario : areas[0].id_area);
    }
  }, [areas, idAreaDireccionUsuario, selectedArea]);

  const handleChangeAreaTab = (newIdArea: number) => {
    setSelectedArea(newIdArea);
    setPage(0);
  };

  const [jefeInmediato, setJefeInmediato] = useState<number>(0);

  const formik = useFormik({
    initialValues: {
      codigo: "",
      razon_social: "",
      nombre_comercial: "",
      direccion: "",
      contacto: "",
      giro: "",
      rfc: "",
      importe_credito: "",
      dias_credito: "",
      tiempo_entrega: "",
      correo: "",
      telefono: "",
    },
    validationSchema: Yup.object({
      codigo: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      razon_social: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      nombre_comercial: Yup.string().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      direccion: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      contacto: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      giro: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      rfc: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      importe_credito: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      dias_credito: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      tiempo_entrega: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      correo: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      telefono: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
    }),
    validateOnMount: true,
    onSubmit: async (values) => {
      //console.log("Formulario enviado:", values);
    },
  });

  const isFieldValid = (fieldName: keyof typeof formik.values) => {
    return (
      formik.touched[fieldName] &&
      !formik.errors[fieldName] &&
      formik.values[fieldName] &&
      formik.values[fieldName] !== ""
    );
  };

  const getFieldColor = (fieldName: keyof typeof formik.values) => {
    return isFieldValid(fieldName) ? "#00AB16" : undefined;
  };

  const getProveedores = useCallback(async () => {
    try {
      setProcesando(true);
      const requisiciones = await getProveedoresHttp();
      setProveedores(requisiciones);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getJefeInmediato = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const jefeInmediato = await getJefeInmediatoHttp(datos);
      setJefeInmediato(jefeInmediato.jefe_inmediato);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getDocumentosFaltantesProveedor = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const response = await getDocumentosFaltantesProveedorHttp(datos);
      setDocumentosProveedor(response);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const subirDocumentoProveedor = async (data: any) => {
    try {
      setProcesandoSubirDocumento(true);

      const formData = new FormData();
      formData.append("id_proveedor", data.id_proveedor);
      formData.append("id_documento", data.id_documento);
      formData.append("id_usuario", data.id_usuario);
      formData.append("archivo", data.archivo);

      const response: any = await subirDocumentoProveedorHttp(formData);

      setDocumentosProveedor((prev) =>
        prev.map((doc) =>
          doc.id === data.id_documento
            ? {
              ...doc,
              subido: 1,
              id_registro: response.documento.id,
              url_archivo: response.documento.url_archivo,
              nombre_documento: response.documento.nombre_documento,
            }
            : doc
        )
      );

      setMensajeAlert(intl.formatMessage({ id: "general_subido_correctamente" }));
      handleisAlertOpen();
      setProcesandoSubirDocumento(false);
      setArchivo(null);
      setIdDocumento(null);
      setIdRegistroDocumento(null);
    } catch (error) {
      setProcesandoSubirDocumento(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_subido_error" }));
      handleisAlertOpen();
    }
  };
  const editarDocumentoProveedor = async (data: any) => {
    try {
      setProcesandoSubirDocumento(true);

      const formData = new FormData();
      formData.append("id_documento", data.id);
      formData.append("id_usuario", data.id_usuario);
      formData.append("archivo", data.archivo);

      const response: any = await editarDocumentoProveedorHttp(formData);

      setDocumentosProveedor((prev) =>
        prev.map((doc) =>
          doc.id === response.documento.id_documento
            ? {
              ...doc,
              subido: 1,
              url_archivo: response.documento.url_archivo,
              nombre_documento: response.documento.nombre_documento,
            }
            : doc
        )
      );

      setMensajeAlert(intl.formatMessage({ id: "general_editado_correctamente" }));
      handleisAlertOpen();
      setProcesandoSubirDocumento(false);
      setArchivo(null);
      setIdDocumento(null);
      setIdRegistroDocumento(null);
    } catch (error) {
      setProcesandoSubirDocumento(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_editado_error" }));
      handleisAlertOpen();
    }
  };

  const eliminarDocumentoProveedor = async (data: any) => {
    try {
      setProcesando(true);
      const response: any = await eliminarDocumentoProveedorHttp(data);

      setDocumentosProveedor((prev) =>
        prev.map((doc) =>
          doc.id === response.id_documento
            ? { ...doc, subido: 0, url_archivo: null, nombre_documento: null, tipo_archivo: null }
            : doc
        )
      );

      setMensajeAlert(intl.formatMessage({ id: "general_eliminado_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_eliminado_error" }));
      handleisAlertOpen();
    }
  };

  const createEditProveedor = async (datos: any) => {
    try {
      setProcesandoProveedor(true);
      const response: any = await createEditProveedorHttp(datos);
      setProveedores((prevProveedores: any[]) => {
        if (verEditarProveedor) {
          return prevProveedores.map((p) => (p.id === response.id ? response : p));
        }
        return [response, ...prevProveedores];
      });
      if (verDetalleProveedor && verDetalleProveedor.id === response.id) {
        setVerDetalleProveedor(response);
      }
      setMensajeAlert(
        verEditarProveedor
          ? intl.formatMessage({ id: "general_editado_correctamente" })
          : intl.formatMessage({ id: "general_añadido_correctamente" })
      );

      if (verEditarProveedor) {
        setVerEditarProveedor(response);
      } else {
        formik.resetForm();
      }

      handleisAlertCloseCrearProveedor();
      handleisAlertOpen();
      setProcesandoProveedor(false);
    } catch (error) {
      setProcesandoProveedor(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(
        message || verEditarProveedor
          ? intl.formatMessage({ id: "error_editado_general" })
          : intl.formatMessage({ id: "error_añadir_general" })
      );
      handleisAlertOpen();
    }
  };

  const desactivarProveedor = async (datos: any) => {
    try {
      setProcesando(true);
      const proveedor: any = await desactivarProveedorHttp(datos);
      setProveedores((prevProveedores: any[]) => {
        return prevProveedores.map((c) => {
          if (c.id === proveedor.id) {
            return {
              ...c,
              estatus: proveedor.estatus,
            };
          }
          return c;
        });
      });
      setMensajeAlert(intl.formatMessage({ id: "general_desactivado_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_desactivado_error" }));
      handleisAlertOpen();
    }
  };
  const activarProveedor = async (datos: any) => {
    try {
      setProcesando(true);
      const proveedor: any = await activarProveedorHttp(datos);
      setProveedores((prevProveedores: any[]) => {
        return prevProveedores.map((t) => {
          if (t.id === proveedor.id) {
            return {
              ...t,
              estatus: proveedor.estatus,
            };
          }
          return t;
        });
      });
      setMensajeAlert(intl.formatMessage({ id: "general_activado_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_activado_error" }));
      handleisAlertOpen();
    }
  };

  useEffect(() => {
    if (verEditarProveedor) {
      formik.setValues({
        codigo: verEditarProveedor?.codigo || "",
        razon_social: verEditarProveedor?.razon_social || "",
        nombre_comercial: verEditarProveedor?.nombre_comercial || "",
        direccion: verEditarProveedor?.direccion || "",
        contacto: verEditarProveedor?.contacto || "",
        giro: verEditarProveedor?.giro || "",
        rfc: verEditarProveedor?.rfc || "",
        importe_credito: verEditarProveedor?.importe_credito || 0,
        dias_credito: verEditarProveedor?.dias_credito || 0,
        tiempo_entrega: verEditarProveedor?.tiempo_entrega || 0,
        correo: verEditarProveedor?.correo || "",
        telefono: verEditarProveedor?.telefono || 0,
      });
    } else {
      formik.resetForm();
    }
  }, [verEditarProveedor]);

  useEffect(() => {
    getProveedores();
  }, []);

  // Handlers para la paginación
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Filtrar por el área seleccionada ANTES de paginar
  const proveedoresFiltrados = useMemo(() => {
    if (selectedArea === null) return proveedores;
    return proveedores.filter((p) => p.id_area === selectedArea);
  }, [proveedores, selectedArea]);

  const proveedoresPaginados = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return proveedoresFiltrados.slice(startIndex, endIndex);
  }, [proveedoresFiltrados, page, rowsPerPage]);

  /*const proveedoresPaginados = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return proveedores?.slice(startIndex, endIndex) || [];
  }, [proveedores, page, rowsPerPage]);*/

  return {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    proveedores,
    //crear proveedor
    isAlertOpenCrearProveedor,
    handleisAlertOpenCrearProveedor,
    handleisAlertCloseCrearProveedor,
    getFieldColor,
    procesandoProveedor,
    createEditProveedor,
    proveedoresPaginados,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    idUsuario,
    getJefeInmediato,
    jefeInmediato,
    verDetalleProveedor,
    setVerDetalleProveedor,
    isAlertOpenDetalleProveedor,
    handleisAlertOpenDetalleProveedor,
    handleisAlertCloseDetalleProveedor,
    verEditarProveedor,
    setVerEditarProveedor,
    desactivarProveedor,
    activarProveedor,
    //añadir documentos al proveedor
    isAlertOpenDetalleDocumentos,
    handleisAlertOpenDetalleDocumentos,
    handleisAlertCloseDetalleDocumentos,
    subirDocumentoProveedor,
    documentosProveedor,
    getDocumentosFaltantesProveedor,
    idDocumento,
    setIdDocumento,
    handleChangeDocumento,
    archivo,
    setArchivo,
    procesandoSubirDocumento,
    //ver documento individualmente
    handleOpenVistaDocumento,
    handleCloseVistaDocumento,
    isModalVistaDocumento,
    documentoSeleccionado,
    eliminarDocumentoProveedor,
    editarDocumentoProveedor,
    setIdRegistroDocumento,
    idRegistroDocumento,
    areas,
    selectedArea,
    handleChangeAreaTab
  };
};
